import React from 'react';
import { useSelector } from 'react-redux';
import Step from './Step';

const RemainingSteps = () => {
  const { steps, firstIncompleteIndex } = useSelector(state => state);

  const remainingSteps = steps.slice(firstIncompleteIndex).map((step, i) => {
    return (
      <Step step={step} index={firstIncompleteIndex + i} key={step.stepId} />
    );
  });

  return <>{remainingSteps}</>;
};

export default RemainingSteps;
